/* eslint-disable jsx-a11y/label-has-associated-control */
import React from 'react';
import PartNumber from 'shared/components/parameters/PartNumber';
import Revision from 'shared/components/parameters/Revision';
import StencilFile from 'shared/components/parameters/StencilFile';
import LengthText from 'shared/components/carriers/LengthText';
import WidthText from 'shared/components/carriers/WidthText';
import PressureHolder from 'shared/components/carriers/PressureHolder';
import PrintConfirmation from 'shared/components/PrintConfirmationRadio';
import SpecialInstruction from 'shared/components/SpecialInstruction';
import ProductQuoteNumber from 'shared/components/ProductQuoteNumber';
import RowSelected from 'shared/components/RowSelected';
import ColumnSelected from 'shared/components/ColumnSelected';
import MaterialThickness from 'shared/components/carriers/MaterialThickness';
import {
  partNumber as partNumberTooltip,
  revision as revisionTooltip,
  materialThickness as materialThicknessTooltip,
  stencilFile as stencilFileTooltip,
  carrierWidth as carrierWidthTooltip,
  carrierLength as carrierLengthTooltip,
  printConfirmation as printConfirmationTooltip,
  pressureHolderType as pressureHolderTypeTooltip,
} from 'surface_mount_carriers/data/tooltips';

const Parameters = (props) => {
  const { parameters, validator } = props;

  validator.purgeFields();

  return (
    <div>
      <div className="row">
        <div className="col-12 col-md-6">
          <PartNumber {...props} tooltip={partNumberTooltip}>
            <span className="error">
              {validator.message(`Part Number`, parameters.part_number, 'required|min:3')}
            </span>
          </PartNumber>
        </div>
        <div className="col-12 col-md-6">
          <Revision
            {...props}
            label="Revision Number"
            tooltip={revisionTooltip}>
            <span className="error">
              {validator.message(`Revision`, parameters.revision, 'required')}
            </span>
          </Revision>
        </div>
        <div className="col-12 col-md-6">
          <MaterialThickness {...props} tooltip={materialThicknessTooltip} />
        </div>
        <div className="col-12 col-md-6">
          <StencilFile
            {...props}
            required
            tooltip={stencilFileTooltip}>
            <span className="error">
              {validator.message(`Zip File`, parameters.filename, 'required')}
            </span>
          </StencilFile>
        </div>
        <div className="col-12">
          <div className="row">
            <div className="col-12 col-md-6">
              <WidthText {...props} tooltip={carrierWidthTooltip}>
                <span className="error">
                  {validator.message(`Carrier Width`, parameters.carrier_width, 'required|numeric|min:0.1,num|max:20,num')}
                </span>
              </WidthText>
            </div>
            <div className="col-12 col-md-6">
              <LengthText {...props} tooltip={carrierLengthTooltip}>
                <span className="error">
                  {validator.message(`Carrier Length`, parameters.carrier_length, 'required|numeric|min:0.1,num|max:24,num')}
                </span>
              </LengthText>
            </div>
          </div>
        </div>
        <div className='col-12'>
          <PrintConfirmation
            {...props}
            required
            tooltip={printConfirmationTooltip}>
            <span className="error">
              {validator.message(`Check plot confirmation`, parameters.print_confirmation, 'required')}
            </span>
          </PrintConfirmation>
        </div>
        <div className="col-12">
          <PressureHolder
            {...props}
            validator={validator}
            pressureHolderTypeTooltip={pressureHolderTypeTooltip} />
        </div>
        <div className="col-12">
          <SpecialInstruction {...props} />
          <ProductQuoteNumber {...props} />
          <RowSelected {...props} />
          <ColumnSelected {...props} />
        </div>
      </div>
      <div className="d-flex justify-content-between">
        <span>
          <label className="error">* Required Information</label>
        </span>
      </div>
    </div>
  );
};

export default Parameters;
